export default "__VITE_ASSET__CoaKOjwI__"